import { useMemo } from 'react';
import { useGetGolfEventSummaryQuery } from '../state/api';
import { selectEventsBySeries } from '../state/entitySelectors';
import { useAppSelector } from '../hooks/reduxHooks';
import TourOverview from './tour-overview';
import { lookupWinningCaptain } from '../utils/members';
import { useTeamCompetitionData } from '../hooks/useTeamCompetitionData';
import type { GolfEventSummary, MemberSummary, TeamCompetition } from '../types/api.types';

const mapEvents = (
  events: GolfEventSummary[] | undefined | null,
  teamCompetitions: Record<string, TeamCompetition>,
  members: MemberSummary[]
) => {
  if (events === undefined || events === null) {
    return null;
  }

  if (teamCompetitions === undefined || teamCompetitions === null || Object.keys(teamCompetitions).length === 0) {
    return null;
  }

  if (members === undefined || members === null || members.length === 0) {
    return null;
  }

  // No need to filter here - already filtered by entity selector
  const eventsWithTeam = events.map((event) => {
    const teamCompetition = teamCompetitions[event.teamCompID!];
    return {
      ...event,
      winningCaptain: lookupWinningCaptain(members, teamCompetition),
    };
  });
  return eventsWithTeam;
};

const TourOverviewContainer = () => {
  const { competitions, members } = useTeamCompetitionData();

  // Fetch data with RTK Query
  useGetGolfEventSummaryQuery();

  // Use entity selector with built-in series filter (memoized)
  const summerTourEvents = useAppSelector((state) => selectEventsBySeries(state, 'Summer Tour'));

  const lstEvents = useMemo(
    () => mapEvents(summerTourEvents, competitions, members) || [],
    [summerTourEvents, competitions, members]
  );

  return <TourOverview lstEvents={lstEvents} />;
};

export default TourOverviewContainer;
